"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var layer_1 = tslib_1.__importDefault(require("../line/layer"));
var global_1 = require("../../base/global");
var _ = tslib_1.__importStar(require("@antv/util"));
var StepLineLayer = /** @class */ (function (_super) {
    tslib_1.__extends(StepLineLayer, _super);
    function StepLineLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'step-line'; // 覆写父类的 type
        return _this;
    }
    StepLineLayer.getDefaultOptions = function () {
        return _.deepMix({}, _super.getDefaultOptions.call(this), {
            step: 'hv',
        });
    };
    return StepLineLayer;
}(layer_1.default));
exports.StepLineLayer = StepLineLayer;
global_1.registerPlotType('step-line', StepLineLayer);
//# sourceMappingURL=layer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/step-line/layer.js
// module id = 984
// module chunks = 37